"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CurrencyContext = require("./CurrencyContext");
var _pricing = require("../helpers/pricing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FormatCurrency = function FormatCurrency(_ref) {
  var baseCurrency = _ref.baseCurrency,
    amount = _ref.amount,
    showCurrency = _ref.showCurrency,
    round = _ref.round;
  var currencyContext = (0, _react.useContext)(_CurrencyContext.CurrencyContext);
  var currency;
  if (showCurrency) {
    currency = showCurrency;
  } else if (currencyContext !== null && currencyContext !== void 0 && currencyContext.currency) {
    currency = currencyContext.currency;
  } else {
    // In the cases where we're not using context or explicitly showing a
    // currency then we just format the base currency (needed on TSW)
    currency = baseCurrency;
  }
  var rates;
  if (currencyContext !== null && currencyContext !== void 0 && currencyContext.rates) {
    rates = currencyContext.rates;
  }
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, (0, _pricing.formatCurrency)(amount, baseCurrency, currency, round, rates));
};
FormatCurrency.propTypes = {
  amount: _propTypes["default"].number.isRequired,
  baseCurrency: _propTypes["default"].string.isRequired,
  showCurrency: _propTypes["default"].string,
  round: _propTypes["default"].bool
};
FormatCurrency.defaultProps = {
  round: true
};
var _default = exports["default"] = FormatCurrency;